// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import * as types from './actionTypes';

export function getParcelShops(postcode) {
  return {
    type: types.REQUEST_PARCEL_SHOPS,
    postcode,
  };
}

export function getParcelShopsSuccess(parcelShops) {
  return {
    type: types.REQUEST_PARCEL_SHOPS_SUCCESS,
    parcelShops,
  };
}

export function getParcelShopsFailed() {
  return {
    type: types.REQUEST_PARCEL_SHOPS_FAILED,
  };
}

export function changeField(value, field) {
  return {
    type: types.PARCEL_SHOPS_CHANGE_FIELD,
    value,
    field
  };
}

export function setPostcode(postcode) {
  return {
    type: types.SET_POSTCODE,
    postcode,
  };
}
